import { DATE_FORMATS_FNS } from "components";
import "modules/AppointmentDetails/components/Interventions/components/InterventionChecklists/InterventionChecklists.scss";
import { formatDate } from "utils/dateHelperFunctions";

import type { CarCheck } from "models";

type ConnectedChecklistsProps = {
  connectedChecks: CarCheck[];
};

export const ConnectedChecklists = ({ connectedChecks }: ConnectedChecklistsProps) => {
  if (!connectedChecks.length) return null;

  return (
    <div className="ConnectedChecklistsContainer">
      {connectedChecks.map((check, index) => (
        <div key={check.id} className="inner-container">
          <div className="row-number-checklist-name-container">
            <div className="row-number">
              <span>{index + 1} </span>
            </div>
            <div className="checklist-name">
              <b>{check.checklist?.name}</b>
            </div>
          </div>

          <div className="mechanic-info-container">
            {check.mechanic && (
              <span>
                {check.mechanic.first_name} {check.mechanic.last_name} {" - "}
              </span>
            )}
            <span>
              {formatDate(check.created_on, DATE_FORMATS_FNS.timeDateMonthYear)} &#8594; {formatDate(check.updated_on, DATE_FORMATS_FNS.timeDateMonthYear)}{" "}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};
